// extracted by mini-css-extract-plugin
export default {"node":"NodeTypes_node__nuD6E","content":"NodeTypes_content__oXk5B","handle":"NodeTypes_handle__edFR4","placeholder":"NodeTypes_placeholder__EGyet"};